
/*
$(".tag__input").change(function () {
  location.reload();
});

$("li.tag--remove").click(function () {
  location.reload();
});
*/

(function () {
  function patchCollectionFilters() {
    if (!window.theme || !theme.Collection) return;

    // Stop the collection filters from scrolling the page
    theme.Collection.prototype.updateScroll = function () {};

    // Remember which sidebar checkbox was used
    var lastFilter = null;

    document.addEventListener('change', function (evt) {
      var input = evt.target;
      if (!input.matches('.collection-sidebar .tag__input')) return;
      lastFilter = { name: input.name, value: input.value };
    });

    // After the AJAX refresh, put keyboard focus back on that checkbox
    document.addEventListener('collection:reloaded', function () {
      if (!lastFilter) return;
      var inputs = document.querySelectorAll('.collection-sidebar .tag__input');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].name === lastFilter.name && inputs[i].value === lastFilter.value) {
          inputs[i].focus({ preventScroll: true });
          break;
        }
      }
      lastFilter = null;
    });
  }

  if (window.theme && theme.Collection) {
    patchCollectionFilters();
  } else {
    document.addEventListener('page:loaded', patchCollectionFilters);
  }
})();


document.addEventListener('collection:reloaded', function () {
  // Remove dropdown menus left behind by the grid that was just replaced
  $('.ui-selectmenu-menu').each(function () {
    var buttonId = $(this).children('ul').attr('aria-labelledby');
    if (buttonId && !document.getElementById(buttonId)) {
      $(this).remove();
    }
  });

  // Rebuild the two-line dropdowns in the new grid
  $('#CollectionAjaxContent .selectdropdown select').multilineSelectmenu();
});


// clear all functionality
(function () {
  var clearedAll = false;

  document.addEventListener('click', function (evt) {
    var link = evt.target.closest('.js-clear-filters');
    if (!link || !window.theme || !theme.sections) return;

    var collection = theme.sections.instances.find(function (instance) {
      return instance.type === 'collection-grid';
    });
    if (!collection) return; // Falls back to the link's normal page load

    evt.preventDefault();
    clearedAll = true;
    collection.startLoading();
    collection.renderCollectionPage(new URLSearchParams());
  });

  // After clearing, put keyboard focus on the first filter checkbox
  document.addEventListener('collection:reloaded', function () {
    if (!clearedAll) return;
    clearedAll = false;
    var firstFilter = document.querySelector('.collection-sidebar .tag__input');
    if (firstFilter) firstFilter.focus({ preventScroll: true });
  });
})();


// Mobile-only functionality for filtering
(function () {
  var drawerChanged = false;

  // On mobile, hold checkbox changes made in the filter drawer instead of applying each one immediately
  document.addEventListener('input', function (evt) {
    if (!window.theme || !theme.config.bpSmall) return;
    if (!evt.target.closest('#FilterDrawer .filter-form')) return;
    evt.stopPropagation();
    drawerChanged = true;
  }, true);

  // When the drawer closes, apply all the held changes at once
  new MutationObserver(function () {
    if (!drawerChanged || document.documentElement.classList.contains('js-drawer-open')) return;
    drawerChanged = false;

    var form = document.querySelector('#FilterDrawer .filter-form');
    var collection = window.theme && theme.sections && theme.sections.instances.find(function (instance) {
      return instance.type === 'collection-grid';
    });
    if (!form || !collection) return;

    collection.startLoading();
    collection.renderFromFormData(new FormData(form));
  }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
})();